import React, { Component } from 'react';

import Checkbox from '@lightspeed/cirrus-checkbox';
import Text, { TextContent } from '@lightspeed/cirrus-text';
import PropTypes from 'prop-types';

import { createReactRenderer } from 'helpers/react-renderer';

const textContent = {
  customer: {
    info: 'To select your customer’s preferred contact method, you need their explicit consent.',
    label: 'Yes, I have consent from my customer.',
  },
  employee: {
    info: "To select your employee's preferred contact method, you need their explicit consent.",
    label: 'Yes, I have consent from my employee.',
  },
};

class ConsentConfirmation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmation: false,
      guiDefsCheckboxes: this.guiDefsGetCheckboxesInitialState(),
    };

    this.hiddenCheckboxRef = React.createRef();
    this.handleCheckConfirmation = this.handleCheckConfirmation.bind(this);
  }

  componentDidMount() {
    this.guiDefsToggleCheckboxes();
  }

  handleCheckConfirmation() {
    this.setState(
      (prevState) => ({
        confirmation: !prevState.confirmation,
      }),
      () => this.guiDefsToggleCheckboxes()
    );
  }

  guiDefsGetCheckboxesInitialState() {
    const { toggleCheckboxes } = this.props;

    return toggleCheckboxes.reduce((guiDefsCheckboxes, id) => {
      const element = document.getElementById(id);
      // eslint-disable-next-line no-param-reassign
      guiDefsCheckboxes[id] = element.checked;
      return guiDefsCheckboxes;
    }, {});
  }

  guiDefsToggleCheckboxes() {
    const { toggleCheckboxes } = this.props;
    const { confirmation } = this.state;

    this.hiddenCheckboxRef.current.checked = confirmation;

    /**
     * When un-checking the consent confirmation box we reset the e-mail/phone/mail checkboxes to the initial state
     */

    if (!confirmation) {
      this.resetGuiDefsCheckboxes();
    }

    toggleCheckboxes.forEach((id) => {
      const element = document.getElementById(id);
      if (element) {
        if (!confirmation) {
          element.setAttribute('disabled', 'disabled');
        } else {
          element.removeAttribute('disabled');
        }
      }
    });
  }

  resetGuiDefsCheckboxes() {
    const { guiDefsCheckboxes } = this.state;

    Object.keys(guiDefsCheckboxes).forEach((id) => {
      const element = document.getElementById(id);
      element.checked = guiDefsCheckboxes[id];
    });
  }

  render() {
    const { confirmation } = this.state;
    const { type, inputProps, disabled } = this.props;
    return (
      <TextContent className="cr-pt-1 cr-pb-2">
        <Text dimmed>{textContent[type].info}</Text>
        <div className="cr-mb-2" />
        <Checkbox
          data-test="consent-confirmation-checkbox"
          label={textContent[type].label}
          checked={confirmation}
          onChange={this.handleCheckConfirmation}
          disabled={disabled}
        />
        <input
          id={inputProps.id}
          name={inputProps.name}
          ref={this.hiddenCheckboxRef}
          className="view_view"
          type="checkbox"
          hidden
        />
      </TextContent>
    );
  }
}

export default ConsentConfirmation;

ConsentConfirmation.propTypes = {
  type: PropTypes.oneOf(['employee', 'customer']).isRequired,
  toggleCheckboxes: PropTypes.arrayOf(PropTypes.string).isRequired,
  disabled: PropTypes.bool,
  inputProps: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
};

const RenderedComponent = createReactRenderer({
  component: ConsentConfirmation,
  selector: '[data-react-root="ConsentConfirmation"]',
});

history.onChangeState(
  {
    name: ['admin.views.employee', 'customer.views.customer', 'customer.views.register_customer'],
    id: undefined,
  },
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
